export default {
  data() {
    return {
      openRow: null,
      openIndependentDrawers: {},
      tableFilterValues: {},
      tableSearchValues: {},
      tablePages: {},
      tableItemsPerPage: {}
    }
  },
  computed: {
    drawerNode() {
      return this.baseScreen ? this.findDrawerNode(this.baseScreen) : null
    },
    currentScreen() {
      const replacement = this.drawerNode ? {
        ...this.drawerNode,
        props: {
          ...this.drawerNode.props,
          value: Boolean(this.openRow),
          title: this.openRow ? (this.openRow.detailTitle || this.drawerNode.props.title) : this.drawerNode.props.title,
          subtitle: this.openRow ? (this.openRow.detailSubtitle || this.drawerNode.props.subtitle) : this.drawerNode.props.subtitle
        },
        children: this.openRow ? (this.openRow.detailContent || []) : []
      } : null
      let replaced = false
      const transformNode = (node) => {
        if (!node || typeof node !== 'object') {
          return node
        }
        if (replacement && node.type === 'detail_drawer') {
          if (replaced) {
            if (process.env.NODE_ENV !== 'production') {
              // eslint-disable-next-line no-console
              console.warn(
                'DashboardIndependentDrawers: mais de um nó "detail_drawer" encontrado — só o primeiro fica interativo, os demais são ignorados.'
              )
            }
            return node
          }
          replaced = true
          return replacement
        }
        const clone = { ...node }
        if (node.type === 'data_table_filter' && node.props) {
          const instance = node.props.instance
          const hasDrawerRows = Array.isArray(node.props.rows) &&
            node.props.rows.some((row) => row && row.detail && Array.isArray(row.detail.children))
          if (instance || hasDrawerRows) {
            clone.props = { ...node.props }
            if (instance) {
              const pageOverride = this.tablePages[instance]
              const itemsPerPageOverride = this.tableItemsPerPage[instance]
              clone.props.filterValues = this.tableFilterValues[instance] || {}
              clone.props.search = this.tableSearchValues[instance] || ''
              clone.props.options = {
                ...(node.props.options || {}),
                ...(pageOverride !== undefined ? { page: pageOverride } : {}),
                ...(itemsPerPageOverride !== undefined ? { itemsPerPage: itemsPerPageOverride } : {})
              }
            }
            if (hasDrawerRows) {
              clone.props.rows = node.props.rows.map((row) => {
                if (!row || !row.detail || !Array.isArray(row.detail.children)) {
                  return row
                }
                return {
                  ...row,
                  detail: {
                    ...row.detail,
                    children: row.detail.children.map(transformNode)
                  }
                }
              })
            }
          }
        }
        if (Array.isArray(node.sections)) {
          clone.sections = node.sections.map(transformNode)
        }
        if (Array.isArray(node.children)) {
          clone.children = node.children.map(transformNode)
        }
        if (node.type === 'accordion_drilldown' && node.props && Array.isArray(node.props.items)) {
          clone.props = {
            ...clone.props,
            items: node.props.items.map((item) => ({
              ...item,
              tabs: Array.isArray(item.tabs)
                ? item.tabs.map((tab) => ({
                  ...tab,
                  children: Array.isArray(tab.children) ? tab.children.map(transformNode) : tab.children
                }))
                : item.tabs
            }))
          }
        }
        return clone
      }
      return transformNode(this.baseScreen)
    },
    openIndependentDrawersList() {
      return Object.keys(this.openIndependentDrawers).map((id) => ({
        id,
        row: this.openIndependentDrawers[id]
      }))
    },
    tableQueryParams() {
      const result = {}
      Object.keys(this.tableFilterValues).forEach((instance) => {
        const values = this.tableFilterValues[instance] || {}
        Object.keys(values).forEach((param) => {
          result[param] = values[param]
        })
      })
      Object.keys(this.tableSearchValues).forEach((instance) => {
        const value = this.tableSearchValues[instance]
        if (value) {
          result[`searchPlaceholder.${instance}`] = value
        }
      })
      Object.keys(this.tablePages).forEach((instance) => {
        result[`page.${instance}`] = this.tablePages[instance]
      })
      Object.keys(this.tableItemsPerPage).forEach((instance) => {
        result[`size.${instance}`] = this.tableItemsPerPage[instance]
      })
      return result
    }
  },
  methods: {
    onRowDetail(row) {
      if (row && row.detail && row.detail.props && row.detail.props.id) {
        this.$set(this.openIndependentDrawers, row.detail.props.id, row)
        return
      }
      this.openRow = row
    },
    onDrawerInput(value) {
      if (!value) {
        this.openRow = null
      }
    },
    onIndependentDrawerInput(id, value) {
      if (!value) {
        this.$delete(this.openIndependentDrawers, id)
      }
    },
    onFilterChange({ instance, param, value } = {}) {
      if (!instance || !param) {
        return
      }
      const current = { ...(this.tableFilterValues[instance] || {}) }
      current[param] = value
      this.$set(this.tableFilterValues, instance, current)
      this.$delete(this.tablePages, instance)
    },
    onTableOptionsChange({ instance, options } = {}) {
      if (!instance || !options) {
        return
      }
      this.$set(this.tablePages, instance, options.page)
      this.$set(this.tableItemsPerPage, instance, options.itemsPerPage)
      if (typeof this.fetchScreen === 'function') {
        this.fetchScreen()
      }
    },
    onFilterSubmit({ instance, value } = {}) {
      if (instance) {
        if (value) {
          this.$set(this.tableSearchValues, instance, value)
        } else {
          this.$delete(this.tableSearchValues, instance)
        }
        this.$delete(this.tablePages, instance)
      }
      if (typeof this.fetchScreen === 'function') {
        this.fetchScreen()
      }
    },
    findDrawerNode(node) {
      if (!node || typeof node !== 'object') {
        return null
      }
      if (node.type === 'detail_drawer') {
        return node
      }
      const lists = [node.sections, node.children].filter(Array.isArray)
      if (node.type === 'accordion_drilldown' && node.props && Array.isArray(node.props.items)) {
        node.props.items.forEach((item) => {
          if (Array.isArray(item.tabs)) {
            item.tabs.forEach((tab) => {
              if (Array.isArray(tab.children)) {
                lists.push(tab.children)
              }
            })
          }
        })
      }
      for (const list of lists) {
        for (const item of list) {
          const found = this.findDrawerNode(item)
          if (found) {
            return found
          }
        }
      }
      return null
    },
    findRowById(node, id) {
      if (!node || typeof node !== 'object') {
        return null
      }
      if (node.type === 'data_table_filter' && node.props && Array.isArray(node.props.rows)) {
        for (const row of node.props.rows) {
          if (row && row.detail && row.detail.props && row.detail.props.id === id) {
            return row
          }
          if (row && row.detail && Array.isArray(row.detail.children)) {
            for (const child of row.detail.children) {
              const found = this.findRowById(child, id)
              if (found) {
                return found
              }
            }
          }
        }
      }
      const lists = [node.sections, node.children].filter(Array.isArray)
      if (node.type === 'accordion_drilldown' && node.props && Array.isArray(node.props.items)) {
        node.props.items.forEach((item) => {
          if (Array.isArray(item.tabs)) {
            item.tabs.forEach((tab) => {
              if (Array.isArray(tab.children)) {
                lists.push(tab.children)
              }
            })
          }
        })
      }
      for (const list of lists) {
        for (const item of list) {
          const found = this.findRowById(item, id)
          if (found) {
            return found
          }
        }
      }
      return null
    },
    resyncOpenDrawers() {
      Object.keys(this.openIndependentDrawers).forEach((id) => {
        const freshRow = this.findRowById(this.currentScreen, id)
        if (freshRow) {
          this.$set(this.openIndependentDrawers, id, freshRow)
        }
      })
    }
  }
}
